import { AxiosError, AxiosResponse } from 'axios';
import { UseMutationOptions } from 'react-query';

import useAPIMutation from '../api/useAPIMutation';
import { JobPostingDetail } from '../types';
import useUpdateVacancyMutation from './useUpdateVacancyMutation';

interface DescriptionMutationVariables {
  description: string;
  competencies?: number[];
  jobPostingId?: JobPostingDetail['id'];
}

const useDescriptionMutation = (
  options?: Omit<
    UseMutationOptions<
      AxiosResponse<JobPostingDetail, unknown>,
      AxiosError<unknown, unknown>,
      DescriptionMutationVariables,
      unknown
    >,
    'mutationFn'
  >
) => {
  const updateVacancyMutation = useUpdateVacancyMutation();

  return useAPIMutation(
    async ({ description, competencies, jobPostingId }: DescriptionMutationVariables, api) => {
      return await updateVacancyMutation.mutateAsync({
        jobPostingId,
        jobPostingFields: {
          description,
          competencies: competencies || [],
        },
      });
    },
    options
  );
};

export default useDescriptionMutation;
